import { IconListItem } from '@cp-shared-19/frontend-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SubrogationInfo } from '../subrogation-info/SubrogationInfo';

export const PrivetePersonInfo: React.FC = () => {
    const { t } = useTranslation('request-subrogation');
    const documentsList: IconListItem[] = [
        {
            label: t('documents.private-person.doc1'),
            icon: 'checkmark',
        },
        {
            label: t('documents.private-person.doc2'),
            icon: 'checkmark',
        },
        {
            label: t('documents.private-person.doc3'),
            icon: 'checkmark',
        },
        {
            label: t('documents.private-person.doc4'),
            icon: 'checkmark',
        },
        {
            label: t('documents.private-person.doc5'),
            icon: 'checkmark',
        },
        {
            label: t('documents.private-person.doc6'),
            icon: 'checkmark',
        },
        {
            label: t('documents.private-person.doc7'),
            icon: 'checkmark',
        },
        {
            label: t('documents.private-person.doc8'),
            icon: 'checkmark',
        },
        {
            label: t('documents.private-person.doc9'),
            icon: 'checkmark',
        },
    ];

    return (
        <SubrogationInfo
            documentsList={documentsList}
            isPrivatePerson={true}
            type={t('subrogation-info.type.value.private-person')}
        />
    );
};
